import React, { useEffect, useState } from "react";
import "./UserHistory.css";
import { useProfile } from '../../context/ProfileContext';
import { useNavigate } from 'react-router-dom';
const fallbackData = {
  Withdraw: [],
  Deposit: []
};

const TransactionPage = () => {
  const [activeTab, setActiveTab] = useState("Withdraw");
  const [data, setData] = useState({ Withdraw: [], Deposit: [] });
  const navigate = useNavigate();
  const { profile } = useProfile();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const user = JSON.parse(localStorage.getItem("user") || "{}");
        const userId = user._id || user.userId;
        if (!userId) throw new Error("No user ID found");
       
        const res = await fetch(`${process.env.REACT_APP_BASE_URL}/api/transactions/${userId}`);
        const result = await res.json();

        if (result.success) {
          setData({
            Withdraw: result.data.withdrawals || [],
            Deposit: result.data.deposits || []
          });
        } else {
          setData(fallbackData);
        }
      } catch (err) {
        console.warn("Using fallback data:", err);
        setData(fallbackData);
      }
    };

    fetchData();
  }, []);

  console.log(data)

  const statusStyle = (status) => status === "Approved" ? "approved" : "pending";

  return (
    <>
     <header className="header">
        <div className="header-left">
          <h1 className="site-title"  onClick={() => navigate('/')}>CricWhizz</h1>
        </div>
        <div className="header-right">
          <div className="wallet-button">
            <span className="wallet-icon">💰</span>
            <span className="wallet-amount">{profile.walletBalance}</span>
          </div>
      
        </div>
      </header>
    
    <div className="premium-container">
      
      <div className="premium-tabs">
        <button
          className={activeTab === "Withdraw" ? "active" : ""}
          onClick={() => setActiveTab("Withdraw")}
        >
          Withdraw
        </button>
        <button
          className={activeTab === "Deposit" ? "active" : ""}
          onClick={() => setActiveTab("Deposit")}
        >
          Deposit
        </button>
      </div>

      <div className="glass-card">
        <div className="table-head">
          <div>Amount</div>
          <div>Status</div>
          <div>Account</div>
          <div>Date</div>
        </div>

        {data[activeTab].length > 0 ? (
          data[activeTab].map((item, i) => (
            <div className="table-row" key={i}>
              <div>₹{item.amount}</div>
              <div className={`status ${statusStyle(item.status)}`}>{item.status}</div>
              <div>{item.account}</div>
              <div>{item.date}</div>
            </div>
          ))
        ) : (
          <div className="no-data">No {activeTab.toLowerCase()} history found.</div>
        )}
      </div>
    </div>
    </>
  );
};

export default TransactionPage;
